import React, { useContext, useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom'
import Login from './components/Login'
import ReportingDashboard from './components/ReportingDashboard'
import Enquiries from './components/Enquiries'
import Customers from './components/Customers'
import Settings from './components/Settings'
import { Box, AppBar, Toolbar, IconButton, CssBaseline, Typography, Container } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import Sidebar from './components/Sidebar'
import { Toaster } from 'react-hot-toast'
import About from './components/About'
import ConnectionStatus from './components/ConnectionStatus'
import DataStatus from './components/DataStatus'

import Promotions from './components/Promotions'
import Notifications from './components/Notifications'
import NotificationBanner from './components/NotificationBanner'
import { GlobalContext } from './context/GlobalContext'
import { getImageFromBlobId, sendMessage } from './lib/api'



const MainApp = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/*" element={<Layout />}>
        <Route path="enquiries" element={<Enquiries />} />
        <Route path="reportingdashboard" element={<ReportingDashboard />} />
        <Route path="customers" element={<Customers />} />
        <Route path="settings" element={<Settings />} />
        <Route path="about" element={<About />} />
        <Route path="promotions" element={<Promotions />} />
        <Route path="notifications" element={<Notifications />} />
      </Route>
    </Routes>
  )
}

const Layout = () => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const { cinfo, apir, brandingBlob, setBrandingBlob } = useContext(GlobalContext)
  const location = useLocation()

  const getPageName = (pathname) => {
    const pageMap = {
      '/enquiries': 'Enquiries',
      '/reportingdashboard': 'Dashboard',
      '/customers': 'Customers',
      '/settings': 'Settings',
      '/about': 'About',
      '/promotions': 'Promotions',
      '/notifications': 'Notifications'
    }
    return pageMap[pathname] || 'Connect+'
  }

  useEffect(() => {
    if (!cinfo) return;
    const ciBlobId = cinfo.CompanyBrandingBlobStorageID;
    getImageFromBlobId(ciBlobId).then((data) => {
      setBrandingBlob(data);
    });
  }, [cinfo]);


  const toggleDrawer = (val) => {
    /*if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }*/
    if (val !== undefined) {
      setDrawerOpen(val)
    } else {
      setDrawerOpen(prev => !prev)
    }
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <NotificationBanner />
      <Toaster />
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: 1199 }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => toggleDrawer()}
            edge="start"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <div style={styles.logoWrapper}>
            <img src={brandingBlob} style={styles.logo} />
          </div>

          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
            {getPageName(location.pathname)}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <DataStatus />
            <ConnectionStatus />
          </Box>
        </Toolbar>
      </AppBar>
      <Sidebar isOpen={drawerOpen} toggleDrawer={toggleDrawer} />
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default' }}>
        <Box
          sx={{
            p: 3,
            paddingTop: 10,
            paddingLeft: 10,
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}
const styles = {
  logoWrapper: {
    padding: 4,
    borderRadius: 14,
    backgroundColor: 'white',
    display: 'inline-block',
    marginRight: 10,
  },
  logo: {
    width: 100,
    height: 40,
    objectFit: 'contain',
    borderRadius: 10,
    display: 'block',
  },
};

export default MainApp
